export const SLUG_API = 'https://devhub.rezcomm.com/hubapmydbauth/brandapi/gtbrnslg.php';
export const BRANDING_API = 'https://devhub.rezcomm.com/hubapmydbauth/brandapi/branddetailslive.php?brandslug=#slug#';
